<template>
  <div v-if="speakingData">
    <p class="text-2xl font-bold text-center mb-4" v-if="selectedStep === 1 && currentPartQuestions?.NameEn && !isToeic && currentPhase !== 'direction' && currentPhase !== 'preContinue'">{{ currentPartQuestions.NameEn }}</p>
    <p class="font-bold text-xl" v-if="isToeic && selectedStep === 1 && currentPhase !== 'direction' && currentPhase !== 'finish' && currentPhase !== 'preContinue'">Question {{ currentPartQuestions.Questions[currentQuestionIndex].Num }} <span v-if="isToeic">of 11</span></p>
    <div class="bg-white w-100 h-100 p-2 p-md-4 speaking_inner mb-2 d-flex justify-content-center mb-3">
      <Precautions v-if="selectedStep === 0" />
      <div v-if="selectedStep === 1" class="w-100 h-100">
        <bridge_direction v-if="currentPhase === 'preContinue' && !isToeic" />

        <div v-if="(isDirection && isToeic) || (isDirection && !isToeic && currentPart === 2)" class="w-100 h-100 mx-auto">
          <p class="max-w-3xl mx-auto text-2xl text-center mb-2 mb-md-4" v-if="currentPartQuestions?.NameEn">{{ currentPartQuestions?.NameEn }}</p>
          <p class="currentPartQuestions_Description max-w-3xl mx-auto text-lg text-left font-bold" v-if="currentPartQuestions?.Description" v-html="currentPartQuestions?.Description?.replace(/(?:\r\n|\r|\n)/g, '<br/>') || ''"></p>
          <p class="stemQuestionsWords max-w-3xl mx-auto text-lg text-left" v-if="currentPartQuestions.stemQuestionsWords && ((!isToeic && isDirection) || (isToeic && (currentPart !== 2 && isDirection)))" v-html="currentPartQuestions?.stemQuestionsWords?.replace(/(?:\r\n|\r|\n)/g, '<br/>') || ''"></p>
          <div class="Description py-3" v-if="(isDirection && !isToeic && (currentPart === 0 || currentPart === 2)) && currentPartQuestions.Questions[currentQuestionIndex]?.Description">
            <p class="max-w-3xl mx-auto text-lg text-left" v-if="currentPartQuestions?.Questions[currentQuestionIndex]?.Description" v-html="currentPartQuestions?.Questions?.[currentQuestionIndex]?.Description?.replace(/(?:\r\n|\r|\n)/g, '<br/>') || ''"></p>
          </div>
        </div>
        <div v-if="(currentPhase !== 'direction' && currentPhase !== 'finish' && currentPhase !== 'isLoadingReport' && currentPhase !== 'preContinue') || (isDirection && !isToeic && currentPart !== 2)">
          <p class="text-xl" v-if="!isToeic && currentPhase !== 'direction'">Question {{ currentPartQuestions?.Questions[currentQuestionIndex].Num }}</p>
          <p class="text-2xl text-center mb-4" v-if="currentPartQuestions?.NameEn && !isToeic && (!isToeic && currentPart !== 2) && isDirection">{{ currentPartQuestions.NameEn }}</p>
          <div class="py-3" v-if="(!isToeic && currentPart !== 2 && isDirection) && currentPartQuestions.Description">
            <p class="currentPartQuestions_Description text-left mb-0 text-lg max-w-3xl mx-auto font-bold" v-html="currentPartQuestions?.Description?.replace(/(?:\r\n|\r|\n)/g, '<br/>') || ''"></p>
          </div>
          <p class="Description max-w-3xl mx-auto text-lg text-left font-bold" v-if="(!isToeic && (currentPhase === 'prepare' || currentPhase === 'response') && currentPart === 5) || (isToeic&& (currentPart !== 1 && currentPart !== 3)) && currentPartQuestions.Questions[currentQuestionIndex].Description" v-html="currentPartQuestions?.Questions?.[currentQuestionIndex]?.Description?.replace(/(?:\r\n|\r|\n)/g, '<br/>') || ''"></p>
          <p class="stemQuestionsWords max-w-3xl mx-auto text-lg text-left" v-if="currentPartQuestions.stemQuestionsWords && ((!isToeic && isDirection && currentPart !== 2) || (!isToeic && !isDirection && currentPart === 5) || (isToeic))" v-html="currentPartQuestions?.stemQuestionsWords?.replace(/(?:\r\n|\r|\n)/g, '<br/>') || ''"></p>
          <p class="Title max-w-3xl mx-auto text-lg text-left" v-if="isToeic && currentPartQuestions.Questions[currentQuestionIndex].Title" v-html="currentPartQuestions?.Questions?.[currentQuestionIndex]?.Title?.replace(/(?:\r\n|\r|\n)/g, '<br/>') || ''"></p>
          <p class="Description max-w-3xl mx-auto text-lg text-left font-bold" v-if="(!isToeic && (currentPhase === 'prepare' || currentPhase === 'response') && currentPart !== 5) || (isToeic&& (currentPart !== 1 && currentPart !== 3)) && currentPartQuestions.Questions[currentQuestionIndex].Description" v-html="currentPartQuestions?.Questions?.[currentQuestionIndex]?.Description?.replace(/(?:\r\n|\r|\n)/g, '<br/>') || ''"></p>
          <p class="Title max-w-3xl mx-auto text-lg text-left"
            v-if="((!isToeic && currentPart !== 0 && currentPart !== 3 && currentPart !== 5 && isDirection)
                || (!isToeic && currentPart === 0 && !isDirection)
                || (!isToeic && currentPart === 2)
                || (!isToeic && currentPart === 3 && currentPhase !== 'direction')) && currentPartQuestions?.Questions[currentQuestionIndex]?.Title"
            v-html="currentPartQuestions?.Questions?.[currentQuestionIndex]?.Title?.replace(/(?:\r\n|\r|\n)/g, '<br/>') || ''">
          </p>
          <div class="max-w-2xl mx-auto p-2 p-md-4" v-if="currentPartQuestions?.Questions[currentQuestionIndex]?.ImageUrl && (isToeic || (!isToeic && currentPhase !== 'direction'))">
            <img :src="currentPartQuestions.Questions[currentQuestionIndex].ImageUrl || ''" alt=""  class="object-contain w-100 h-100">
          </div>
          <div class="max-w-2xl mx-auto p-2 p-md-4" v-if="currentPartQuestions?.stemInformationPic && (isToeic || (!isToeic && isDirection))">
            <img :src="currentPartQuestions.stemInformationPic" alt=""  class="object-contain w-100 h-100">
          </div>
        </div>

        <div class="speaking_inner d-flex justify-content-center flex-column" v-if="currentPhase === 'finish'">
          <p class="text-2xl text-center">This is the end of the speaking test.</p>
          <p class="text-xl text-center">Your session is now complete.</p>
        </div>
        <div class="speaking_inner d-flex justify-content-center flex-column align-items-center" v-if="currentPhase === 'isLoadingReport'">
          <LottieAnimation class="max-w-lg mx-auto mb-4"
            :animationData="require('@/assets/image/toeic/toeic_exam/RobotWithCat.json')"
            :loop="true"
            :auto-play="true"
            :speed="1" />
          <p class="text-2xl text-center font-bold">成績計算中......</p>
        </div>
      </div>
    </div>
    <!-- buttons -->
    <div v-if="selectedStep === 0">
      <!-- <div class="radio-row d-flex justify-content-center mb-2">
        <div class="form-check mr-3">
          <input class="form-check-input" type="radio" name="countdownMode" id="auto" :value="true" checked v-model="isManualSkip">
          <label class="form-check-label radio-label text-blue-main-toeic" for="auto">
            自動倒數
          </label>
        </div>

        <div class="form-check">
          <input class="form-check-input" type="radio" name="countdownMode" id="manual" :value="false" v-model="isManualSkip">
          <label class="form-check-label radio-label text-blue-main-toeic" for="manual">
            手動倒數
          </label>
        </div>
      </div> -->
      <a class="bg-blue-lighter-toeic text-white px-5 py-2 d-inline-block font-bold text-xl pointer d-lg-inline-block" @click="start_exam()">START</a>
    </div>
    <!-- bridge說明階段 -->
    <div class="text-white text-xl d-flex flex-column" v-if="selectedStep === 1 && currentPhase === 'preContinue'">
      <div class="row mx-auto font-bold mb-2">
        <a class="bg-blue-lighter-toeic text-white p-3 py-2 d-inline-block font-bold text-xl pointer" @click="continue_exam()">Continue</a>
      </div>
    </div>
    <!-- 說明階段 -->
    <div class="text-white text-xl d-flex flex-column" v-if="selectedStep === 1 && isDirection">
      <div class="row mx-auto font-bold mb-2">
        <p class="bg-blue-lighter-toeic py-2 px-3 mb-0">DIRECTIONS</p>
        <p class="py-2 px-3 text-blue-main-toeic border-blue-main-toeic border mb-0">{{ formatSeconds(answer_count) }}</p>
      </div>
      <p class="text-blue-main-toeic" v-if="isToeic">The countdown will end and the question will begin</p>
    </div>
    <!-- 準備階段 -->
    <div class="text-white text-xl d-flex flex-column" v-if="selectedStep === 1 && currentPhase === 'prepare'">
      <div class="row mx-auto font-bold mb-2">
        <p class="bg-blue-lighter-toeic py-2 px-3 mb-0">PREPARATION TIME</p>
        <p class="py-2 px-3 text-blue-main-toeic border-blue-main-toeic border mb-0">{{ formatSeconds(answer_count) }}</p>
      </div>
      <p class="text-blue-main-toeic">Recording will start automatically after time</p>
    </div>
    <!-- 錄音階段 -->
    <div class="text-white text-xl d-flex flex-column" v-if="selectedStep === 1 && currentPhase === 'response'">
      <div class="row mx-auto font-bold mb-2">
        <div class="bg-blue-lighter-toeic d-flex align-items-center">
          <RecognitionS v-on:emitAudioData="emitAudioData" />
          <p class="bg-blue-lighter-toeic py-2 px-3 mb-0">RESPONSE TIME</p>
        </div>
        <p class="py-2 px-3 text-blue-main-toeic border-blue-main-toeic border mb-0">{{ formatSeconds(answer_count) }}</p>
      </div>
    </div>
    <!-- done -->
    <div class="text-white text-xl d-flex flex-column" v-if="selectedStep === 1 && currentPhase === 'done' && isManualSkip">
      <div class="row mx-auto font-bold mb-2">
        <div class="bg-blue-lighter-toeic loading p-3">
          <img :src="require('@/assets/image/toeic/toeic_exam/loading.png')" alt="" class="object-contain w-100 h-100 onreconation_icon">
        </div>
      </div>
    </div>
    <a @click="manualNext" v-if="selectedStep === 1 && currentPhase === 'done' && !isManualSkip"
      class="bg-blue-lighter-toeic text-white p-3 py-2 d-inline-block font-bold text-xl pointer">NEXT
    </a>
    <!-- finish -->
    <a class="bg-blue-lighter-toeic text-white p-3 py-2 d-inline-block font-bold text-xl pointer" v-if="currentPhase === 'finish'" @click="getReport()" :class="{ 'bg-secondary': !allPosted }">REPORT</a>
  </div>
</template>

<script>
  import Precautions from '@/components/AiHelper/toeic/precautions'
  import RecognitionS from '@/components/AiHelper/toeic/RecognitionS'
  import bridge_direction from '@/components/AiHelper/toeic/bridge_direction'
  import examJs from '@/components/AiHelper/examJs_toeic.js'
  import keepAwakeMixin from '@/components/AiHelper/toeic/keepAwakeMixin'
  import UltraStableAudioPlayer from '@/components/AiHelper/toeic/UltraStableAudioPlayer'
  import LottieAnimation from 'lottie-web-vue'
  export default {
    name: 'Speaking',
    props: {
      speakingData: {
        type: Array
      }
    },
    mixins: [
      examJs, keepAwakeMixin, UltraStableAudioPlayer
    ],
    data () {
      return {
        sessionToken: 0,
        isManualSkip: true,
        isTimerPaused: false,

        selectedStep: 0,
        currentPart: 0,
        currentQuestionIndex: 0,

        currentPhase: 'direction', // 'preContinue' 'direction' | 'prepare' | 'response' | 'done' | 'finish' | 'allFinish' | 'isLoadingReport'

        answer_count: 5,
        timer: null,
        interval: null,

        sound_effect: null,

        isPostingRecord: false,

        audioContext: null,
        beep: {
          beep_duration: 0.2,
          beep_frequency: 1000,
          beep_volume: 0.6
        },
        exam_timers: [
          { index: 0,
            direction: 30,
            prepare: 0,
            times: [
              { num: 0, prepare: 45, response: 45, repeat: 1 },
              { num: 1, prepare: 45, response: 45, repeat: 1 }
            ]
          },
          { index: 1,
            direction: 30,
            prepare: 0,
            times: [
              { num: 2, prepare: 45, response: 30, repeat: 1 },
              { num: 3, prepare: 45, response: 30, repeat: 1 }
            ]
          },
          { index: 2,
            direction: 30,
            prepare: 0,
            times: [
              { num: 4, prepare: 3, response: 15, repeat: 1 },
              { num: 5, prepare: 3, response: 15, repeat: 1 },
              { num: 6, prepare: 3, response: 30, repeat: 1 }
            ]
          },
          { index: 3,
            direction: 30,
            prepare: 45,
            times: [
              { num: 7, prepare: 3, response: 15, repeat: 1 },
              { num: 8, prepare: 3, response: 15, repeat: 1 },
              { num: 9, prepare: 3, response: 30, repeat: 2 }
            ]
          },
          { index: 4,
            direction: 30,
            prepare: 0,
            times: [
              { prepare: 45, response: 60, repeat: 1 }
            ]
          }
        ],
        bridge_timers: [
          { index: 0,
            direction: 25,
            prepare: 0,
            times: [
              { num: 0, prepare: 25, response: 30, repeat: 1 },
              { num: 1, prepare: 25, response: 30, repeat: 1 }
            ]
          },
          { index: 1,
            direction: 25,
            prepare: 0,
            times: [
              { num: 2, prepare: 30, response: 30, repeat: 1 },
              { num: 3, prepare: 30, response: 30, repeat: 1 }
            ]
          },
          { index: 2,
            direction: 25,
            prepare: 0,
            times: [
              { num: 4, prepare: 15, response: 30, repeat: 1 }
            ]
          },
          { index: 3,
            direction: 25,
            prepare: 0,
            times: [
              { num: 5, prepare: 30, response: 30, repeat: 1 }
            ]
          },
          { index: 4,
            direction: 25,
            prepare: 0,
            times: [
              { num: 6, prepare: 45, response: 60, repeat: 1 }
            ]
          },
          { index: 5,
            direction: 25,
            prepare: 0,
            times: [
              { num: 7, prepare: 60, response: 60, repeat: 1 }
            ]
          }
        ],
        tempStatusArray: []
      }
    },
    computed: {
      isToeic () {
        return this.$route.name === 'TOEIC_exam'
      },
      isDirection () {
        return this.currentPhase === 'direction'
      },
      partTime () {
        if (this.isToeic) {
          return this.exam_timers[this.currentPart]
        }
        return this.bridge_timers[this.currentPart]
      },
      textLength () {
        return this.textVal ? this.textVal.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, '').split(' ').filter(word => word.length > 0).length : 0
      },
      currentPartQuestions () {
        return this.speakingData[this.currentPart]
      },
      allPosted () {
        return this.tempStatusArray.every(item => item.isPost === true)
      }
    },
    components: {
      Precautions, RecognitionS, bridge_direction, LottieAnimation
    },
    beforeDestroy () {
      this.audio_stop()
      this.disableKeepAwake()

      if (this.interval) clearInterval(this.interval)
      if (this.timer) clearInterval(this.timer)
      this.interval = this.timer = null

      if (this.onUserGesture) {
        document.removeEventListener('touchstart', this.onUserGesture, true)
        document.removeEventListener('click', this.onUserGesture, true)
      }

      if (this.sound_effect) {
        try { this.sound_effect.pause() } catch {}
        this.sound_effect.onended = null
        this.sound_effect.onerror = null
        this.sound_effect.src = ''
      }

      if (this.audioContext) {
        try { this.audioContext.close() } catch {}
        this.audioContext = null
      }
    },
    async mounted () {
      if (this.$route.query.q) {
        this.currentPart = this.$route.query.q
      }

      this.initTempStatusArray()

      this.initTimers()

      if (!this.isToeic) {
        this.currentPhase = 'preContinue'
      }

      if (!this.$route.query.record_id) {
        this.$router.push({ name: 'Search'})
      }
    },
    methods: {
      async ensureAudioContext () {
        if (!this.audioContext) {
          this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
        }

        const ctx = this.audioContext;
        if (ctx.state === "running") return;

        try {
          await ctx.resume();
          if (ctx.state === "running") return
        } catch (e) {
          console.warn("AudioContext 立即解鎖失敗", e);
        }

        return new Promise(resolve => {
          const resumeContext = async () => {
            try {
              await ctx.resume();
              if (ctx.state === "running") {
                removeListeners();
                resolve();
              }
            } catch (_) {}
          };

          const onGesture = () => {
            resumeContext();
          };

          const removeListeners = () => {
            document.removeEventListener("touchstart", onGesture, true);
            document.removeEventListener("click", onGesture, true);
          };

          document.addEventListener("touchstart", onGesture, true);
          document.addEventListener("click", onGesture, true);
        });
      },

      initTempStatusArray () {
        this.speakingData.forEach((part, partIndex) => {
          part.Questions.forEach((question, questionIndex) => {
            this.tempStatusArray.push({
              partIndex,
              questionIndex,
              isPost: false,
              isSuccessPost: false,
              questionId: question.Id,
              title: question.Title,
              Name: part.Name
            })
          })
        })
      },

      async playBeep() {
        await this.ensureAudioContext()

        const ac = this.audioContext

        // ==== 1. 嘗試 Oscillator ====
        try {
          if (ac.state === 'suspended') await ac.resume()

          if (ac.state === 'running') {
            return await new Promise(resolve => {
              let settled = false

              const osc = ac.createOscillator()
              const gain = ac.createGain()

              osc.type = 'sine'
              osc.frequency.value = this.beep?.beep_frequency || 1000
              gain.gain.value = this.beep?.beep_volume || 0.8

              osc.connect(gain)
              gain.connect(ac.destination)

              osc.start()

              const duration = this.beep?.beep_duration || 0.25
              osc.stop(ac.currentTime + duration)

              const finalize = () => {
                if (settled) return
                settled = true
                try { osc.disconnect(); gain.disconnect(); } catch (_) {}
                resolve()
              }

              osc.onended = finalize

              setTimeout(finalize, duration * 1000 + 200)
            });
          }
        } catch (err) {
          console.warn('[playBeep] oscillator failed, fallback to buffer', err)
        }

        // ==== 2. AudioBuffer（iOS 最穩） ====
        try {
          const duration = this.beep?.beep_duration || 0.25;
          const sampleRate = ac.sampleRate;
          const frameCount = sampleRate * duration;

          const buffer = ac.createBuffer(1, frameCount, sampleRate);
          const data = buffer.getChannelData(0);

          const freq = this.beep?.beep_frequency || 1000;
          const volume = this.beep?.beep_volume || 0.8;

          for (let i = 0; i < frameCount; i++) {
            data[i] = volume * Math.sin(2 * Math.PI * freq * (i / sampleRate));
          }

          const source = ac.createBufferSource();
          source.buffer = buffer;
          source.connect(ac.destination);

          return await new Promise(resolve => {
            let settled = false;

            const finalize = () => {
              if (settled) return;
              settled = true;
              try { source.disconnect(); } catch (_) {}
              resolve();
            };

            source.onended = finalize;
            source.start(0);

            setTimeout(finalize, duration * 1000 + 200);
          });
        } catch (err) {
          console.warn('[playBeep] buffer beep failed, fallback to audio file', err);
        }

        // ==== 3. 最終 fallback ====
        return new Promise(resolve => {
          try {
            const a = new Audio(this.beepFallbackUrl || '');
            a.play()?.catch(() => {}).finally(resolve);
          } catch (_) {
            resolve();
          }
        });
      },

      async initTimers () {
        if (!this.speakingData) return

        const isExam = this.isToeic
        const extra = isExam ? 0 : 0
        const targetTimers = isExam ? this.exam_timers : this.bridge_timers

        for (let i = 0; i < this.speakingData.length; i++) {
          const url = this.speakingData[i].DescriptionAudioUrl

          if (!url) {
            targetTimers[i].direction = extra
            console.warn(`大題 ${i + 1} 沒有音檔 URL，預設時間: ${extra}`)
            continue
          }

          let duration = 0;
          let attempt = 0;
          const maxRetries = 3;
          let isSuccess = false;

          while (attempt < maxRetries && !isSuccess) {
            attempt++;
            try {
              duration = await this.loadAudioDuration(url)

              if (duration > 0) {
                isSuccess = true
              } else {
                throw new Error('讀取失敗或長度為 0');
              }
            } catch (err) {
              console.warn(`大題 ${i + 1} 音檔載入失敗 (第 ${attempt} 次嘗試): ${url}`);

              if (attempt === maxRetries) {
                console.error(`大題 ${i + 1} 音檔載入最終失敗: ${url}`, err);
                alert(`大題 ${i + 1} 的說明音檔載入失敗，請檢查網路連線並重新整理頁面！`);
                duration = 0
              } else {

                await new Promise(resolve => setTimeout(resolve, 500));
              }
            }
          }

          targetTimers[i].direction = Math.ceil(duration + extra)
        }
      },

      // async start_exam () {
      //   this.selectedStep = 1
      //   await this.ensureAudioContext()
      //   await this.enableKeepAwake()
      //   if (this.isToeic) {
      //     try {
      //       this.currentQuestionIndex === 0 ? this.setAudio(this.currentPartQuestions.DescriptionAudioUrl) : null
      //       this.answer_count = this.partTime.times[this.currentQuestionIndex].prepare
      //       this.startCountdown(this.partTime.direction, 'prepare', false)
      //     } catch (e) {
      //       console.warn('播放失敗', e)
      //     }
      //   }
      // },
      async start_exam () {
        this.sessionToken++ // 加入防護
        this.selectedStep = 1
        await this.ensureAudioContext()
        await this.enableKeepAwake()

        if (this.isToeic) {
          try {
            if (this.currentQuestionIndex === 0 && this.currentPartQuestions.DescriptionAudioUrl) {
              // 正常倒數 direction 時間，但不自動跳階段
              this.startCountdown(this.partTime.direction, null, false)
              
              // 耐心等待說明音檔完全念完 (記得用 safeSetAudio)
              await this.safeSetAudio(this.currentPartQuestions.DescriptionAudioUrl, true)
              
              // 音檔念完後，才交接給下一題的 prepare 階段
              this.nextPhase('prepare')
            } else {
              this.nextPhase('prepare')
            }
          } catch (e) {
            console.warn('播放失敗', e)
          }
        }
      },
      async continue_exam () {
        this.currentPhase = 'direction'
        let withBeep = this.$route.name === 'TOEIC_bridge' && this.currentPart !== 2 && this.currentPart !== 3 && this.currentPart !== 5 ? true : false

        await this.ensureAudioContext()
        await this.enableKeepAwake()
        try {
          this.currentPartQuestions.DescriptionAudioUrl && this.currentQuestionIndex === 0 ? this.setAudio(this.currentPartQuestions.DescriptionAudioUrl) : null
          this.startCountdown(this.partTime.direction, 'prepare', withBeep)
        } catch (e) {
          console.warn('播放失敗', e)
          // alert('continue_exam 播放失敗', e)
        }
      },

      // startCountdown (duration, nextPhase, withBeep = false) {
      //   return new Promise(resolve => {
      //     this.selectedStep = 1
      //     this.answer_count = duration

      //     if (this.timer) clearInterval(this.timer)
      //     this.timer = setInterval(async () => {
      //       if (this.answer_count > 0) {
      //         this.answer_count--
      //       } else {
      //         clearInterval(this.timer)
      //         this.timer = null

      //         if (withBeep) await this.playBeep()
      //         if (nextPhase) this.nextPhase(nextPhase)

      //         resolve()
      //       }
      //     }, 1000)
      //   })
      // },
      startCountdown (duration, nextPhase, withBeep = false) {
        const currentToken = this.sessionToken

        return new Promise(resolve => {
          this.selectedStep = 1
          this.answer_count = duration

          if (this.timer) clearInterval(this.timer)
          this.timer = setInterval(async () => {
            
            if (this.sessionToken !== currentToken) {
              clearInterval(this.timer)
              this.timer = null
              return 
            }

            // ★ 新增防護：如果畫面正在顯示點擊遮罩，暫停扣秒數！
            if (this.isTimerPaused) return;

            if (this.answer_count > 0) {
              this.answer_count--
            } else {
              clearInterval(this.timer)
              this.timer = null

              if (this.sessionToken !== currentToken) return 

              if (withBeep) await this.playBeep()
              if (nextPhase) this.nextPhase(nextPhase)

              resolve()
            }
          }, 1000)
        })
      },
      async manualNext () {
        if (this.isManualSkip) return
        await this.ensureAudioContext()
        this.setPartQuestion()
      },

      async nextPhase (phase) {
        this.currentPhase = phase
        // toeic
        if (this.isToeic) {
          if (this.currentPart === 3) {
            const stemInformationAudio = this.currentPartQuestions.stemInformationAudio
            this.answer_count = this.partTime.prepare
            stemInformationAudio ? await this.safePlayAudio({ url: this.currentPartQuestions.stemInformationAudio, repeat: 1, withBeep: false }) : null

            await this.startCountdown(this.partTime.prepare)

            this.currentQuestionIndex = 0
            this.answer_count = this.partTime.times[this.currentQuestionIndex].prepare
            await this.safePlayAudio({ url: this.currentPartQuestions.Questions[this.currentQuestionIndex].AudioUrl, repeat: 1, withBeep: false })
            await this.startCountdown(this.partTime.times[this.currentQuestionIndex].prepare, null, true)

            this.currentPhase = 'response'
            await this.startCountdown(this.partTime.times[this.currentQuestionIndex].response)

            this.currentQuestionIndex = 1
            this.currentPhase = 'prepare'
            this.answer_count = this.partTime.times[this.currentQuestionIndex].prepare
            await this.safePlayAudio({ url: this.currentPartQuestions.Questions[this.currentQuestionIndex].AudioUrl, repeat: 1, withBeep: false })
            await this.startCountdown(this.partTime.times[this.currentQuestionIndex].prepare, null, true)
            this.currentPhase = 'response'
            await this.startCountdown(this.partTime.times[this.currentQuestionIndex].response)

            this.currentQuestionIndex = 2
            this.currentPhase = 'prepare'
            this.answer_count = this.partTime.times[this.currentQuestionIndex].prepare
            await this.safePlayAudio({ url: this.currentPartQuestions.Questions[this.currentQuestionIndex].AudioUrl, repeat: 2, withBeep: false })
            await this.startCountdown(this.partTime.times[this.currentQuestionIndex].prepare, null, true)
            this.currentPhase = 'response'
            await this.startCountdown(this.partTime.times[this.currentQuestionIndex].response)

            this.currentPhase = 'done'
            this.isManualSkip ? this.setPartQuestion() : null
          } else if (this.currentPart === 4) {
            this.currentQuestionIndex = 0
            this.answer_count = this.partTime.times[this.currentQuestionIndex].prepare
            await this.safePlayAudio({ url: this.currentPartQuestions.Questions[this.currentQuestionIndex].AudioUrl, repeat: 1, withBeep: false })
            await this.startCountdown(45)
            this.currentPhase = 'response'
            await this.startCountdown(60)

            this.currentPhase = 'done'
            this.isManualSkip ? this.setPartQuestion() : null
          } else {
            if (phase === 'prepare') {
              const audioUrl = this.currentPartQuestions.Questions[this.currentQuestionIndex].AudioUrl
              const stemQuestionsAudio = this.currentPartQuestions.stemQuestionsAudio
              const prepareTime = this.partTime.times[this.currentQuestionIndex].prepare

              this.answer_count = prepareTime
              let withBeep = this.currentPart === 2 ? true : false

              if (stemQuestionsAudio && this.currentQuestionIndex === 0) {
                await this.safePlayAudio({ url: this.currentPartQuestions.stemQuestionsAudio, repeat: 1, withBeep: false })
              }

              if (audioUrl) {
                this.safeSetAudio(audioUrl, true).then(async () => {
                  this.startCountdown(prepareTime, 'response', withBeep)
                })
              } else {
                this.startCountdown(prepareTime, 'response', withBeep)
              }

            } else if (phase === 'response') {
              this.startCountdown(this.partTime.times[this.currentQuestionIndex].response, 'done')
            } else if (phase === 'done') {
              this.isManualSkip ? this.setPartQuestion() : null
            }
          }
        }
        // bridge
        if (!this.isToeic) {
          if (this.currentPart === 2) {
            try {
              this.answer_count = this.partTime.times[this.currentQuestionIndex].prepare
              await this.safePlayAudio({ url: this.currentPartQuestions.Questions[this.currentQuestionIndex].AudioUrl, repeat: 1, withBeep: true })
              this.currentPhase = 'prepare'
              await this.startCountdown(15, null, true)
              this.currentPhase = 'response'
              await this.startCountdown(30, null, false)

              this.currentPhase = 'done'
              this.isManualSkip ? this.setPartQuestion() : null
            } catch (e) {
              console.warn(e)
            }
          } else if (this.currentPart === 3 || this.currentPart === 5) {
            this.answer_count = this.partTime.times[this.currentQuestionIndex].prepare
            await this.safePlayAudio({ url: this.currentPartQuestions.Questions[this.currentQuestionIndex].AudioUrl, repeat: 1, withBeep: true })
            this.currentPhase = 'prepare'
            await this.startCountdown(this.partTime.times[this.currentQuestionIndex].prepare, null, true)
            this.currentPhase = 'response'
            await this.startCountdown(this.partTime.times[this.currentQuestionIndex].response, null, false)

            this.currentPhase = 'done'
            this.isManualSkip ? this.setPartQuestion() : null
          } else {
            if (phase === 'prepare') {
              const audioUrl = this.currentPartQuestions.Questions[this.currentQuestionIndex].AudioUrl
              const stemQuestionsAudio = this.currentPartQuestions.stemQuestionsAudio
              const prepareTime = this.partTime.times[this.currentQuestionIndex].prepare
              this.answer_count = prepareTime

              if (stemQuestionsAudio && this.currentQuestionIndex === 0) {
                await this.safePlayAudio({ url: this.currentPartQuestions.stemQuestionsAudio, repeat: 1, withBeep: false })
              }
              if (audioUrl) {
                this.safeSetAudio(audioUrl, true).then(async () => {
                  if (this.currentQuestionIndex > 0) await this.playBeep()
                  await this.startCountdown(prepareTime, 'response', true)
                })
              } else {
                if (this.currentQuestionIndex > 0) await this.playBeep()
                await this.startCountdown(prepareTime, 'response', true)
              }
            } else if (phase === 'response') {
              this.startCountdown(this.partTime.times[this.currentQuestionIndex].response, 'done', false)
            } else if (phase === 'done') {
              this.isManualSkip ? this.setPartQuestion() : null
            }
          }
        }
      },

      async setPartQuestion () {
        const part = this.currentPartQuestions

        if (!part || !Array.isArray(part.Questions)) {
          console.warn('currentPartQuestions 結構不符預期:', part)
          return
        }
        const isLastQuestion = this.currentQuestionIndex >= this.currentPartQuestions.Questions.length - 1
        const isLastPart = this.currentPart >= this.speakingData.length - 1

        if (!isLastQuestion) {
          this.currentQuestionIndex++

          if (this.currentPart === 3 && this.isToeic) {
            this.nextPhase('response')
          } else {
            await this.nextPhase('prepare')
          }

        } else if (isLastPart) {
          this.currentPhase = 'finish'
          console.log('考試結束')
          this.disableKeepAwake()

        } else {
          // 換下一個 part
          this.currentPart++
          this.currentQuestionIndex = 0
          this.currentPhase = 'direction'
          this.isToeic ? this.start_exam() : this.continue_exam()
          console.log('下一part')
        }
      },

      async emitAudioData (audioData) {
        const item = this.tempStatusArray.find(item => item.isPost === false) || null
        if (!item) {
          console.log('所有題目都已上傳完成')
          return
        }
        console.log(item)
        const result = await this.post_assessments_records(
          this.$route.query.record_id,
          item.questionId,
          item.Name,
          item.title,
          audioData)

        if (result) {
          console.log('emit result:', result)
          item.isSuccessPost = true
        }
        item.isPost = true
      },

      audio_stop () {
        return new Promise(resolve => {
          if (this.sound_effect) {
            try {
              // 移除事件、暫停、重設位置
              this.sound_effect.onended = null
              this.sound_effect.onerror = null
              // 某些情況下 .pause() 會 throw，包 try
              try { this.sound_effect.pause() } catch (e) {}
              try { this.sound_effect.currentTime = 0 } catch (e) {}
              // 清除 src，並呼叫 load 以釋放資源
              try {
                this.sound_effect.removeAttribute && this.sound_effect.removeAttribute('src')
                this.sound_effect.src = ''
                this.sound_effect.load && this.sound_effect.load()
              } catch (e) {}
            } catch (e) {
              console.warn('[audio_stop] stop failed', e)
            }
          }
          resolve()
        })
      },

      formatSeconds (seconds) {
        const mins = String(Math.floor(seconds / 60)).padStart(2, '0')
        const secs = String(seconds % 60).padStart(2, '0')
        return `${mins}:${secs}`
      },

      async getReport () {
        if (!this.allPosted) {
          console.log(this.tempStatusArray)
          return
        }

        this.currentPhase = 'isLoadingReport'
        this.post_assessments_records_finish(this.$route.query.record_id)
      },

      // async loadAudioDuration (url) {
      //   if (!this.sound_effect) {
      //     this.sound_effect = new Audio()
      //   }

      //   return new Promise((resolve) => {
      //     const audio = this.sound_effect
      //     audio.src = url

      //     const onLoaded = () => {
      //       audio.removeEventListener('loadedmetadata', onLoaded)
      //       audio.removeEventListener('error', onError)
      //       resolve(audio.duration)
      //     }

      //     const onError = (e) => {
      //       audio.removeEventListener('loadedmetadata', onLoaded)
      //       audio.removeEventListener('error', onError)
      //       console.warn('音檔載入失敗:', e)
      //       resolve(0)
      //     }

      //     audio.addEventListener('loadedmetadata', onLoaded)
      //     audio.addEventListener('error', onError)

      //     audio.load()
      //   })
      // },
      async loadAudioDuration (url) {
        // ★ 建立獨立的 Audio，絕不干擾 this.sound_effect
        const tempAudio = new Audio() 

        return new Promise((resolve) => {
          tempAudio.src = url

          const onLoaded = () => {
            tempAudio.removeEventListener('loadedmetadata', onLoaded)
            tempAudio.removeEventListener('error', onError)
            resolve(tempAudio.duration)
          }

          const onError = (e) => {
            tempAudio.removeEventListener('loadedmetadata', onLoaded)
            tempAudio.removeEventListener('error', onError)
            console.warn('音檔長度載入失敗:', e)
            resolve(0)
          }

          tempAudio.addEventListener('loadedmetadata', onLoaded)
          tempAudio.addEventListener('error', onError)
          tempAudio.load()
        })
      },
      replaceBr (text) {
        return text ? text.replace(/(?:\r\n|\r|\n)/g, '<br/>') : ''
      }
    }
  }
</script>

<style lang="scss" scoped>
a {
  &:hover {
    text-decoration: none !important;
  }
}
.speaking_inner {
  min-height: calc(60vh);
}
.loading {
  width: 60px;
  height: 60px;
}
.onreconation_icon {
  transform: translate(-50%, -50%);
  animation: move 2s linear infinite;
  transform-origin: center;
}
@keyframes move {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.bg-gray-direction {
  background-color: #D8D8D8;
}
</style>
